import type { TemplateSuggestion } from './types';

export interface RankedSuggestions {
  votable: TemplateSuggestion[];
  promoted: TemplateSuggestion[];
}

function time(value: string | null): number {
  return value ? new Date(value).getTime() : 0;
}

/**
 * Splits the ranking into the list people can still vote on and the list of
 * ideas we already built. Ties go to the older suggestion, so being early is
 * worth something.
 */
export function rankSuggestions(list: TemplateSuggestion[]): RankedSuggestions {
  const votable = list
    .filter((s) => s.status === 'public')
    .slice()
    .sort((a, b) => (b.vote_count - a.vote_count) || (time(a.createdAt) - time(b.createdAt)));

  const promoted = list
    .filter((s) => s.status === 'promoted')
    .slice()
    .sort((a, b) => time(b.promoted_at) - time(a.promoted_at));

  return { votable, promoted };
}
